import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from './other.slice';
import axios from 'axios';

const initialState = {
    data: [],
    users: [],
    trips: [],
    total: 0,
    pages: 0,
    current: 0,
    error: null,
    bookings: [],
    mechanics: [],
    loading: false,
}

export const DriverListReq = createAsyncThunk('DriverListReq', async ({ page, country, text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/partner/driver/list?page=${page}&country=${country}&text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const DriverTripsReq = createAsyncThunk('DriverTripsReq', async ({ page, country, text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/partner/driver/rides?page=${page}&country=${country}&text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const allUsersReq = createAsyncThunk('allUsersReq', async ({ page, text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/partner/dashboard/users?page=${page}&text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        if (error?.response?.data?.error) {
            dispatch(toastError(error?.response?.data?.error))
        }
        return error;
    }
})

export const partnerBookingReq = createAsyncThunk('partnerBookingReq', async ({ role, page, country, text, status, date, datet }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/partner/bookings/${role}?page=${page}&country=${country}&text=${text}&status=${status}&date=${date}&type=${datet}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        if (error?.response?.data?.error) {
            dispatch(toastError(error?.response?.data?.error))
        }
        return error;
    }
})

export const mechanicListReq = createAsyncThunk('mechanicListReq', async ({ page, country, text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/partner/mechanics/list?page=${page}&country=${country}&text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        if (error?.response?.data?.error) {
            dispatch(toastError(error?.response?.data?.error))
        }
        return error;
    }
})

export const PartnerModuleSlice = createSlice({
    name: 'PartnerModuleSlice',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(DriverListReq.pending, (state, action) => {
            state.loading = true
            state.total = 0
            state.pages = 0
            state.current = 0
            state.data = []
            return state
        })
        builder.addCase(DriverListReq.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload.data?.drivers
            state.total = action.payload.data?.total
            state.pages = action.payload.data?.pages
            state.current = action.payload.data?.current
            return state
        })
        builder.addCase(DriverListReq.rejected, (state, action) => {
            state.loading = false
            state.total = 0
            state.pages = 0
            state.current = 0
            state.data = []
            state.error = 'Error occured'
        })
        builder.addCase(DriverTripsReq.pending, (state, action) => {
            state.loading = true
            state.total = 0
            state.pages = 0
            state.current = 0
            state.trips = []
            return state
        })
        builder.addCase(DriverTripsReq.fulfilled, (state, action) => {
            state.loading = false
            state.trips = action.payload.data?.rides
            state.total = action.payload.data?.total
            state.pages = action.payload.data?.pages
            state.current = action.payload.data?.current
            return state
        })
        builder.addCase(DriverTripsReq.rejected, (state, action) => {
            state.loading = false
            state.trips = []
            state.total = 0
            state.pages = 0
            state.current = 0
            state.error = 'Error occured'
        })
        builder.addCase(allUsersReq.pending, (state, action) => {
            state.loading = true
            state.total = 0
            state.pages = 0
            state.current = 0
            state.users = []
            return state
        })
        builder.addCase(allUsersReq.fulfilled, (state, action) => {
            state.loading = false
            state.users = action.payload.data?.drivers
            state.total = action.payload.data?.total
            state.pages = action.payload.data?.pages
            state.current = action.payload.data?.current
            return state
        })
        builder.addCase(allUsersReq.rejected, (state, action) => {
            state.loading = false
            state.total = 0
            state.pages = 0
            state.current = 0
            state.users = []
            state.error = 'Error occured'
        })
        builder.addCase(partnerBookingReq.pending, (state, action) => {
            state.loading = true
            state.total = 0
            state.pages = 0
            state.current = 0
            state.bookings = []
            return state
        })
        builder.addCase(partnerBookingReq.fulfilled, (state, action) => {
            state.loading = false
            state.bookings = action.payload.data?.bookings
            state.total = action.payload.data?.total
            state.pages = action.payload.data?.pages
            state.current = action.payload.data?.current
            return state
        })
        builder.addCase(partnerBookingReq.rejected, (state, action) => {
            state.loading = false
            state.total = 0
            state.pages = 0
            state.current = 0
            state.bookings = []
            state.error = 'Error occured'
        })
        builder.addCase(mechanicListReq.pending, (state, action) => {
            state.loading = true
            state.total = 0
            state.pages = 0
            state.current = 0
            state.mechanics = []
            return state
        })
        builder.addCase(mechanicListReq.fulfilled, (state, action) => {
            state.loading = false
            state.mechanics = action.payload.data?.mechanics
            state.total = action.payload.data?.total
            state.pages = action.payload.data?.pages
            state.current = action.payload.data?.current
            return state
        })
        builder.addCase(mechanicListReq.rejected, (state, action) => {
            state.loading = false
            state.total = 0
            state.pages = 0
            state.current = 0
            state.mechanics = []
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default PartnerModuleSlice.reducer